import { Location } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { pipe } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import { SubSink } from '@core/utils/subsink';
import { BlockActionType } from '@core/enums';
import { Block } from '@core/models/block/block.model';
import { ButtonHandlerService } from '@core/services/button-handler.service';

import { AuthService } from '@app/auth/services/auth.service';
import { SnackBarMessageComponent } from '@app/shared/components/snack-bar-message.component';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';

@Component({
    selector: 'app-password-reset-form',
    template: `
    <form [formGroup]="formGroup">
      <div app-block-container [children]="specialBlock.children"></div>
    </form>
  `,
    providers: [FormService],
    standalone: false
})
export class PasswordResetFormComponent implements OnInit, OnDestroy {
  @Input() specialBlock: Block;
  formGroup = this._fs.formGroup;
  private subSink = new SubSink();

  constructor(private _snackBar: MatSnackBar,
              private _as: AuthService,
              private _fs: FormService,
              public _location: Location,
              private _buttonHandlerService: ButtonHandlerService) {
  }

  ngOnInit(): void {
    this.subSink.sink =
      this._buttonHandlerService.click$
        .pipe(
          filter(({actionType}) => actionType === BlockActionType.SUBMIT && this._fs.formGroup.valid),
          pipe(
            switchMap(({actionData}) =>
              this._as.passwordReset(actionData.path, this.formGroup.getRawValue())))
        ).subscribe(
        {
          next: (success: any) => {
            if (success) {
              this._snackBar
                .openFromComponent(SnackBarMessageComponent, {data: 'registerForm.success'})
                .afterDismissed()
                .subscribe(() => this._location.back());
            } else {
              this._snackBar.openFromComponent(SnackBarMessageComponent, {data: 'registerForm.error'});
            }
          },
          error: () => this._snackBar.openFromComponent(SnackBarMessageComponent, {data: 'registerForm.unknown'}),
        });

    this.subSink.sink =
      this._buttonHandlerService.click$
        .pipe(
          filter(({actionType}) => actionType === BlockActionType.CANCEL))
        .subscribe(() => this._location.back());
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
